import { Injectable } from '@angular/core';
import {
  fetchAndActivate,
  getAll,
} from 'firebase/remote-config';
import { remoteConfig } from '../firebase.config';

@Injectable({ providedIn: 'root' })
export class FirebaseRemoteConfigService {
  
  async loadConfig(): Promise<void> {
    try {
      const activated = await fetchAndActivate(remoteConfig);
      console.log('Remote Config fetched:', activated);
    } catch (error) {
      console.error('Remote Config fetch failed:', error);
    }
  }

  getAllConfig(): Record<string, any> {
    const all = getAll(remoteConfig);
    const parsed: Record<string, any> = {};

    Object.keys(all).forEach((key) => {
      const value = all[key].asString();

      try {
        parsed[key] = JSON.parse(value);
      } catch {
        parsed[key] = value;
      }
    });

    return parsed;
  }
}
